import angular from 'angular';

import StopPropagationModule from './stop-propagation';
import PreventDefaultModule from './prevent-default';
import MailToModule from './mail-to';

export default angular
    .module('common.directive', [
        StopPropagationModule.name,
        PreventDefaultModule.name,
        MailToModule.name
    ]);



// WEBPACK FOOTER //
// ./src/common/directive/index.js